import type { RutaProd } from '../../../../runtime/rutas';
export default { ruta: '/sistema/pos/surtido-bodega/imprimir/{db}/{id}', documento: 'pos', acceso: 'sesion', filas: ['037'], cita: 'prod:Areas/POS/Controllers/SurtidoBodegaController.cs:213' } satisfies RutaProd;
